export type SupportedLanguages = Record<string, string>;

export type Translate = (key: string, values?: Record<string, string> | undefined) => string;

export type Translations = Record<string, string>;

export type Languages = Record<string, string>;

export type LanguageTranslations = Record<keyof SupportedLanguages, Translations>;
